export var validatePassword = function validatePassword(password) {
  var minMaxLength = /^[\s\S]{8,32}$/,
      upper = /[A-Z]/,
      lower = /[a-z]/,
      number = /[0-9]/,
      special = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
  var valid = true;
  var message = '';

  if (minMaxLength.test(password) && upper.test(password) && lower.test(password) && number.test(password) && special.test(password)) {
    return {
      valid: valid,
      message: message
    };
  } else {
    valid = false;

    if (!minMaxLength.test(password)) {
      message = 'The password should be between 8 and 32 characters in length';
    } else if (!upper.test(password)) {
      message = 'At least one uppper case letter should be included';
    } else if (!lower.test(password)) {
      message = 'At least one lower case letter should be included';
    } else if (!number.test(password)) {
      message = 'At least one number should be included';
    } else if (!special.test(password)) {
      message = 'At least one special letter should be included';
    }

    return {
      valid: valid,
      message: message
    };
  }
};
export var validateEmail = function validateEmail(email) {
  var re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  var valid = re.test(String(email).toLowerCase());
  var message = valid ? '' : 'Please input valid email!';
  return {
    valid: valid,
    message: message
  };
};
export var validateMobile = function validateMobile(mobile) {
  var valid = true;
  var message = '';

  if (!/^1[34578]\d{9}$/.test(mobile)) {
    valid = false;
    message = 'please input valid mobile';
    return {
      valid: valid,
      message: message
    };
  }

  return {
    valid: valid,
    message: message
  };
};
export var validateMobileOnlyNumber = function validateMobileOnlyNumber(mobile) {
  var valid = true;
  var message = '';

  if (!/^[0-9]*$/.test(mobile)) {
    valid = false;
    message = 'please input valid mobile';
    return {
      valid: valid,
      message: message
    };
  }

  return {
    valid: valid,
    message: message
  };
};
export var validatePhoneNumber = function validatePhoneNumber(value) {
  var valid = true;
  var message = '';
  var reg = /^([\d]+|\([\d]*\))([\d+-.\s]{1})*\d+$/;
  var regSpecial = /[!"#$%&'*,/:;<=>?@[\\\]^_`{|}~]+/;

  if (regSpecial.test(value)) {
    valid = false;
    message = 'Please only use +, -, ( ), ., and spaces to divide phone numbers in this section.';
    return {
      valid: valid,
      message: message,
      type: 'special'
    };
  }

  if (!reg.test(value)) {
    valid = false;
    message = 'please input valid mobile';
  }

  return {
    valid: valid,
    message: message
  };
};